import { LeagueParticipant } from '../models';
import { LeagueRepository } from '../repositories';

export class GetLeagueParticipantsUseCase {
  constructor(private leagueRepository: LeagueRepository) {}

  async execute(leagueId: string): Promise<LeagueParticipant[]> {
    return await this.leagueRepository.getParticipants(leagueId);
  }
}
